export default __webpack_public_path__ + "static/media/signin2.930940e2.png";